export default __webpack_public_path__ + "static/media/ceo_tamara.b08ca744.png";